import { UseFormClearErrors, UseFormSetError } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { SourceWallet } from 'types/move/move'
import { roundNumberWithCommas } from 'utils/utils'
import { MovePayload } from '../../../../NestedCustomers/types'

interface UseFormAmountErrorProps {
  setError: UseFormSetError<MovePayload>
  clearErrors: UseFormClearErrors<MovePayload>
}

export const useValidateFormAmount = ({ clearErrors, setError }: UseFormAmountErrorProps) => {
  const { t } = useTranslation()

  const validateAmount = (amount: string, sourceWallet: SourceWallet) => {
    const isAmountMoreThanBalance = Number(amount) > sourceWallet?.balance
    const error =
      isAmountMoreThanBalance &&
      t('customers.amountErrorMaximum', {
        amount: roundNumberWithCommas(sourceWallet?.balance),
        currencyCode: sourceWallet?.currency,
      })

    if (error) {
      setError('amount', { message: error })
    } else {
      clearErrors('amount')
    }
  }

  return { validateAmount }
}
